import { render, staticRenderFns } from "./Uf.vue?vue&type=template&id=261ebc4e"
import script from "./Uf.vue?vue&type=script&lang=js"
export * from "./Uf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports